import React, { useState, useContext, useEffect } from "react";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import { convertToHTML } from "draft-convert";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./index.css";

export default function TextEditorEdit(props) {
  const [editorState, setEditorState] = useState(
    props.content
      ? EditorState.createWithContent(
          ContentState.createFromBlockArray(convertFromHTML(props.content))
        )
      : EditorState.createEmpty()
  );

  const [content, setContent] = useState("");

  const removeTags = (str) => {
    if (str === null || str === "") return false;
    else str = str.toString();
    return str.replace(/(<([^>]+)>)/gi, "");
  };

  const handleChange = (editorState) => {
    const content = removeTags(convertToHTML(editorState.getCurrentContent()));

    props.handleContent(content);
    setContent(content);
  };

  return (
    <Editor
      defaultEditorState={editorState}
      onEditorStateChange={handleChange}
      wrapperClassName="wrapper-class"
      editorClassName="editor-class"
      toolbarClassName="toolbar-class"
      disable="disable"
      readOnly={props.toggleState === "file" ? true : false}
    />
  );
}
